import React, { Component } from 'react';
import './myaccount.css';
import { apiService } from '../../common/apiCallService.js';
import { baseUrl } from '../../common/config.js';
import Loading from '../../components/Loading';
import {logoutActivityTrack} from '../../common/commonService';
import { Redirect } from 'react-router';
import * as actions from '../../store/actions/index';
import { connect } from 'react-redux';


class MyAccount extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            loading: false,
            userData: {},
            updateObj: {},
            updateStatus:false,
            errorObj: {},
            updateError: '',
            toggleStatus: false,
            loginRedirect:false,
            location:'/'
        }
    }
   
  resetStore = async () => {
    await this.props.resetStore()
    const loginPath = localStorage.getItem('loggedInType')
    logoutActivityTrack()
    this.logout(loginPath)
  }
  
  logout = (loginPath) => {
    if (loginPath === 'MyGame') this.setState({ location: '/mygamelogin' })
    else if (loginPath === 'PartyPoker') this.setState({ location: '/' })
    else if (loginPath === 'Danskespil') this.setState({ location: '/loggedOut' })
    this.setState({ loginRedirect: true })
  }
    componentDidMount() {
        this.callApi();
    }
    updateUser = () => {
        const { updateObj } = this.state
        let { updateError } = this.state
        this.setState({
            loading: true
        })
        apiService(baseUrl + "/appUser/updateAccountDetails",
            updateObj,
            (data) => {
                this.callApi();
            }, (err) => {
                updateError = err.responseJSON.err
                this.setState({ updateError })
            })
    }
    callApi = () => {
        this.setState({
            loading: true
        })
        apiService(baseUrl + '/appUser/getAccountDetails',
            {

            }
            ,
            (data) => {
                // console.log('data',data);
                this.setState({
                    userData: data,
                    loading: false,
                    updateObj: {},
                    updateStatus:false,
                    errorObj: {}
                })
            }, (err) => {
                this.setState({
                    loading: false,
                })
                console.log(err);
            })

    }
    handleInputChange = (obj) => {
        // console.log('obj', obj);
        let { updateObj,updateStatus } = this.state;
        updateObj = { ...updateObj, ...obj }
        if(updateObj.email && updateObj.email.trim()!=""
        || updateObj.password && updateObj.password.trim()!="" 
        || updateObj.fullName && updateObj.fullName.trim()!="") {
            updateStatus = true;
        }else {
            updateStatus = false;
        }
        this.setState({
            updateObj,
            updateStatus
        })
    }

    verifyUserEmailOrAccountName = () => {
        const { updateObj, userData } = this.state;
        let { errorObj } = this.state;
        if (updateObj && updateObj.email === userData.email) {
            //errorObj['emailError']='Updating email should not be the same'
            delete updateObj.email;
        }
        else if (updateObj && userData.fullName!=""&& updateObj.fullName === userData.fullName) {
            // errorObj['fullNameError']='Updating fullname should not be the same'
            delete updateObj.fullName;
        }
        if (updateObj.email || updateObj.fullName) {
            apiService(baseUrl + '/pokerWatch/verifyUserEmailOrAccount',
                updateObj, (data) => {
                    // console.log('data', data);
                    errorObj = { ...data }
                    if (errorObj['emailError'] && errorObj['fullNameError']) {
                        this.callApi();
                    }

                    this.setState({ errorObj })
                }, (err) => {
                    console.log(err);
                })
        }
    }
    toggleAccount = () => {
        this.setState({
            toggleStatus: !this.state.toggleStatus
        })
    }
    render() {
        const { updateObj, userData, errorObj, toggleStatus,updateStatus } = this.state;
        return <div>
            {this.state.loginRedirect && (<Redirect to={this.state.location} />)}
            {this.state.loading ? <Loading /> : null}
            <div className="myaccount-side-pane">
                <span className="myaccount-header">
                    My Account
                        </span>
                {window.innerWidth > 1024 ? <div>
                    <span className="account-details background-details">
                        Account Details
                            </span>
                    <span className="account-details " onClick={this.resetStore}>
                        LogOut
                            </span>
                </div> : 
                        <div className = "main-account-details" style={{ height: toggleStatus ? '150px' : '40px',display:'block'}}>
                            <span className= {`account-details ${toggleStatus ? " account-border" : ""}`}>Account Details 
                                <i className="fa fa-chevron-down down-arrow-myaccount" onClick={this.toggleAccount}></i>
                            </span>
                        {toggleStatus && <span className="account-details account-border" style={{marginTop:'9.5px'}}><span className="account-details-color"></span> Account Details</span>}
                            {toggleStatus && <span className="account-details account-border"  onClick={this.resetStore}>LogOut</span>}
                        </div>
                   }
            </div>
            <div className="myaccount-main-pane">
                <div className="detail-header">
                    <span>Details</span>
                </div>
                <div className="input-details">
                    <span className="input-lable">Full Name</span>
                    <input type="text" className="input-text" placeholder="  eg: John Snow" data-e2e="account-full-name"
                        value={updateObj.fullName || userData.fullName}
                        disabled={(userData.fullName && userData.fullName != "") ? "disabled" : ""} 
                        style={userData.fullName&& userData.fullName!= "" ? { cursor: 'not-allowed' } : {}}
                        onBlur={() => this.verifyUserEmailOrAccountName()}
                        onChange={(event) => { this.handleInputChange({ "fullName": event.target.value }) }}
                    />
                    {errorObj.fullNameError && <span className="account-error">{errorObj.fullNameError}</span>}
                    <span className="input-lable">Email</span>
                    <input type="text" className="input-text" placeholder="  example@gmail.com" data-e2e="account-email"
                        value={updateObj.email || userData.email}
                        onBlur={() => this.verifyUserEmailOrAccountName()}
                        onChange={(event) => { this.handleInputChange({ "email": event.target.value }) }}
                    />
                    {errorObj.emailError && <span className="account-error">{errorObj.emailError}</span>}
                    <span className="input-lable">Password</span>
                    <input type="text" className="input-text" placeholder="  ********" data-e2e="account-password"
                        value={updateObj.password}
                        onChange={(event) => { this.handleInputChange({ "password": event.target.value }) }}
                    />
                    <button className="input-save-buttion"
                     disabled={!updateStatus || errorObj.fullNameError || errorObj.emailError ? "disabled" : ""} 
                     style={!updateStatus || errorObj.fullNameError || errorObj.emailError ? { cursor: 'not-allowed' } : {backgroundColor:'#E8490D',color: 'white'}}
                    onClick={updateStatus && !errorObj.fullNameError && !errorObj.emailError ?this.updateUser:()=>{}}> Save </button>
                </div>
            </div>
        </div>
    }
}

  
  const mapDispatchToProps = dispatch => {
    return {
      resetStore: () => dispatch(actions.resetStore()),
    }
  };
  export default connect('', mapDispatchToProps)(MyAccount);



/** WEBPACK FOOTER **
 ** ./src/components/AppUser/MyAccount.js
 **/